import Tone from 'tone';

const hzToRadians = (hz) => {
    return hz * 6.283185;
};

const secondsToRadians = (sec) => {
    return sec * 0.00007268518;
};

const degreesToRadians = (deg) => {
    return deg * 0.0174533;
};

export default superclass => class extends superclass  {
    getValue(depth) {
        let period= this.lfoRateParameter.toSeconds(depth+1);
        let time = // Tone.Master.context.isOffline ?
            // Tone.Master.context._currentTime :
            this.sequencerEngine.nextTimeScheduled;// Tone.Master.context.currentTime;
        if (this.stoppedTime) {
            return 0;
        }
        let phaseShift = period*(this.lfoPhaseParameter.get(false, depth+1) / 360);
        time = time - this.startTime;
        let periods = (time - phaseShift) / period;
        let lfoMax = this.lfoMaxParameter.get(false, depth+1);
        let lfoMin = this.lfoMinParameter.get(false, depth+1);
        let amp = (lfoMax - lfoMin) / 2;
        let midPoint = (lfoMax + lfoMin) / 2;

        let type = this.lfoType;
        let v = 0;
        switch(type) {
        case 'sine':
            v = this.getSineValue(periods, amp, midPoint);
            break;
        case 'square':
            v = this.getSquareValue(periods);
            break;
        case 'triangle':
            v = this.getTriangleValue(periods, amp, midPoint);
            break;
        case 'sawtooth':
            v = this.getSawtoothValue(periods, amp, midPoint);
            break;
        }
        return isNaN(v) ? 0 : v;
    }

    getSineValue(periods, amp, midPoint) {
        let v = amp * Math.sin(periods * (2 * Math.PI)) + midPoint;
        return v;
    }

    getTriangleValue(periods, amp, midPoint) {
        return midPoint + amp * (Math.asin(Math.sin(periods * (Math.PI / 2) * Math.PI)));
    }

    getSawtoothValue(periods, amp, midPoint) {
        return this.lfoMin + amp * (0.5 * arcctg(ctg(periods *  Math.PI)));
    }

    getSquareValue(periods) {
        let v = Math.sin(periods * (2 * Math.PI));
        if (v <= 0) {
            return this.lfoMin;
        } else {
            return this.lfoMax;
        }
    }
}

function ctg(x) { return 1 / Math.tan(x); }
function arcctg(x) { return Math.PI / 2 - Math.atan(x); }
